import React, { useEffect, useState } from 'react';
import { Box, TextField, FormHelperText, TableCell, TableRow } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { getIn } from 'formik';
import NumberFormatText from '../../common/form/NumberFormatText';
import { getNumberComma } from '../../../utils/numberUtils';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const SalesPlanForm = ({ index, bill, formik, isManualVat, setIsApplied, planRowDelete, targetExpSales, tempTotalSalAmtSum }) => {
  const [localAmt, setLocalAmt] = useState(bill.salAmt || '');
  const [localVat, setLocalVat] = useState(bill.salVat || '');
  const [localBal, setLocalBal] = useState(bill.salBal || '');
  const [localTotalAmt, setLocalTotalAmt] = useState(bill.totalSalAmt || '');

  useEffect(() => { 
    setLocalAmt(bill.salAmt); 
    setLocalVat(bill.salVat); 
    setLocalBal(bill.salBal); 
    setLocalTotalAmt(bill.totalSalAmt); 
  }, [bill.salAmt, bill.salVat, bill.salBal, bill.totalSalAmt]);

  const syncToFormik = () => {
    const numAmt = Number(String(localAmt).replace(/[^0-9.-]+/g, "")) || 0;
    const numVat = Number(String(localVat).replace(/[^0-9.-]+/g, "")) || 0;
    
    const path = `purchaseBills[${index}]`;
    formik.setFieldValue(`${path}.salAmt`, localAmt);
    formik.setFieldValue(`${path}.salVat`, localVat);
    formik.setFieldValue(`${path}.salBal`, localBal);
    formik.setFieldValue(`${path}.totalSalAmt`, numAmt + numVat);
  };

  const salDt = `purchaseBills[${index}].salDt`;
  const touchedSalDt = getIn(formik.touched, salDt);
  const errorSalDt = getIn(formik.errors, salDt);

  const colDt = `purchaseBills[${index}].colDt`;
  const touchedColDt = getIn(formik.touched, colDt);
  const errorColDt= getIn(formik.errors, colDt);

  const salAmt = `purchaseBills[${index}].salAmt`;
  const touchedSalAmt = getIn(formik.touched, salAmt);
  const errorSalAmt = getIn(formik.errors, salAmt);

  const salVat = `purchaseBills[${index}].salVat`;
  const touchedSalVat = getIn(formik.touched, salVat);
  const errorSalVat = getIn(formik.errors, salVat);

  const prodCompDt = `purchaseBills[${index}].prodCompDt`;
  const touchedProdCompDt = getIn(formik.touched, prodCompDt);
  const errorProdCompDt = getIn(formik.errors, prodCompDt);

  const invAmt = `purchaseBills[${index}].invAmt`;
  const touchedInvAmt = getIn(formik.touched, invAmt);
  const errorInvAmt = getIn(formik.errors, invAmt);

  const invVat = `purchaseBills[${index}].invVat`;
  const touchedInvVat = getIn(formik.touched, invVat);
  const errorInvVat = getIn(formik.errors, invVat);

  const salDet = `purchaseBills[${index}].salDet`;
  const touchedSalDet = getIn(formik.touched, salDet);
  const errorSalDet = getIn(formik.errors, salDet);

  const osTran = `purchaseBills[${index}].osTran`;

  const buyDiv = `purchaseBills[${index}].buyDiv`;
  const touchedBuyDiv = getIn(formik.touched, buyDiv);
  const errorBuyDiv = getIn(formik.errors, buyDiv);

  const [message, setMessage] = useState('');

  const isLocked = formik.values.purchaseBills[index].invYn !== 'N';

  const changeDiv = (divder) => {
    if (divder !== '' && divder !== null) {
      const alotal = parseInt(bill?.billSumTotal);
      const itotal = parseInt(bill?.billIssuedTotal);
      const total = alotal - itotal;

      const div = parseInt(divder);

      const val = Math.round(total / div);
      formik.setFieldValue(invAmt, val);
    }
  };

  const changeVal = (value) => {
    const total = parseInt(bill?.billSumTotal);
    const billIssuedTotal = parseInt(bill?.billIssuedTotal);
    const val = parseInt(value);

    const vat = val / 10;
    if (!checked && vat > 0) {
      formik.setFieldValue(invVat, vat);
    }

    //기매입가 + 매입가 > 총매입가
    if (total < billIssuedTotal + val) {
      const over = billIssuedTotal + val - total;
      setMessage(`${getNumberComma(over)} 초과`);
    } else {
      setMessage('');
    }
  };

  const getInvVat = (idx) => {
    const item = formik.values.purchaseBills[idx];
    
    // 1. 숫자 외 문자(콤마 등) 제거 후 숫자로 변환
    const invAmt = Number(String(item.invAmt).replace(/[^0-9.-]+/g, "")) || 0;

    // 2. 부가세 계산 (10%)
    const vat = Math.floor(invAmt / 10); // 소수점 처리(절사) 추가

    // 3. 필드 업데이트 (0원이어도 업데이트 되도록 조건 제거)
    formik.setFieldValue(`purchaseBills[${idx}].invVat`, vat);
    
    // 4. 합계금액도 필요하다면 여기서 같이 업데이트
    formik.setFieldValue(`purchaseBills[${idx}].totalAmt`, invAmt + vat);
  };

  const [checked, setChecked] = useState(false);
  const [disabled, setDisalbed] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
    formik.setFieldValue(osTran, event.target.checked ? 'Y' : 'N');

    if (event.target.checked) {
      //해외 거래가 체크되어 있으면
      setDisalbed(true);
      //formik.setFieldValue(invVat, 0);
    } else {
      setDisalbed(false);
     // getInvVat();
    }
  };

  useEffect(() => {
    if (formik?.values?.purchaseBills[index]?.osTran === 'Y') {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [formik?.values?.purchaseBills[index]?.osTran]);

  const getAdaptiveFontSize = (value) => {
    const rawValue = String(value || '').replace(/,/g, ''); // 기존 콤마 제거 후 순수 숫자만 추출
    if (!rawValue) return '0.875rem';
    // 콤마가 포함될 실제 시각적 길이 계산 (순수 숫자 길이 + 예상 콤마 개수)
    const commaCount = rawValue.length > 3 ? Math.floor((rawValue.length - 1) / 3) : 0;
    const totalLength = rawValue.length + commaCount;
    if (totalLength > 18) return '0.65rem'; // 1,000,000,000,000 (조 단위 이상)
    if (totalLength > 16) return '0.75rem'; // 100,000,000 (억 단위)
    if (totalLength > 14) return '0.8rem';  // 10,000,000 (천만 단위)
    return '0.875rem';                      // 기본 (body2 크기)
  };

  return (
    <>
      <TableRow
        sx={{ 
          '& .MuiTableCell-root': { 
            fontSize: '0.875rem', 
            padding: '8px 4px', // 셀 패딩 통일
            textAlign: 'center',
            verticalAlign: 'middle' 
          },
          '& .MuiInputBase-root': {
            fontSize: '0.875rem',
            margin: '0 auto',
            marginTop: 0, // 상단 여백 제거
          },
          '& .MuiInputBase-input': { 
            padding: '2px 0 3px 0', // 텍스트와 하단 선 사이 간격 조절
            textAlign: 'center' 
          },
          // 에러 메시지가 라인을 밀어내지 않도록 설정
          '& .MuiFormHelperText-root': {
            position: 'absolute',
            bottom: '-18px',
            margin: 0,
            fontSize: '0.65rem',
            whiteSpace: 'nowrap'
          },
          '& .MuiIconButton-root': { p: '4px' },
          '& .number-cell': { 
            textAlign: 'right',
            fontVariantNumeric: 'tabular-nums' // 숫자 폭을 일정하게 고정
          },
          backgroundColor: isLocked ? 'rgba(0, 0, 0, 0.04)' : 'inherit' 
        }}
      >
        <TableCell sx={{width:30}}>
          {formik.values.purchaseBills[index].invNo}
        </TableCell>

        <TableCell sx={{ width: 120, px: 1 }}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="salDt"
              name="salDt"
              value={formik.values.purchaseBills[index].salDt}
              disabled={isLocked}
              onChange={(newValue) => {
                setIsApplied(false);
                formik.setFieldValue(salDt, newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  fullWidth
                  error={Boolean(touchedSalDt && errorSalDt)}
                  helperText={
                    touchedSalDt && errorSalDt ? errorSalDt : ''
                  }
                />
              )}
            />
          </LocalizationProvider>
        </TableCell>
        <TableCell sx={{ width: 150 }}>{formik.values.purchaseBills[index].partnerNm}</TableCell>
        <TableCell>
          <TextField
            variant="standard"
            required
            size="small"
            fullWidth
            disabled={isLocked}
            id="salDet"
            helperText={touchedSalDet && errorSalDet ? errorSalDet : ''}
            error={Boolean(touchedSalDet && errorSalDet)}
            defaultValue={formik.values.purchaseBills[index].salDet}
            onChange={(e) => {
                setIsApplied(false);
              }
            }
            onBlur={(e) => {
              formik.setFieldValue(salDet, e.target.value); 
              formik.handleBlur(e); // 유효성 검사 실행
            }}
          />
        </TableCell>
        <TableCell align="center" sx={{ width: 50 }}>
          <Checkbox
            name={osTran}
            checked={checked}
            disabled={isLocked}
            onChange={handleChange}
            inputProps={{ 'aria-label': osTran }}
          />
        </TableCell>
        <TableCell 
          align="right" 
          sx={{
            width:"130px",
            textAlign: 'right',
            fontSize: getAdaptiveFontSize(formik.values.purchaseBills[index].expSales),
            paddingRight: '16px' // 우측 여백 확보
          }}
        >
          {getNumberComma(formik.values.purchaseBills[index].expSales)}
        </TableCell>
        <TableCell 
          sx={{
            width: "130px", // 여유 있게 조정
            textAlign: 'right !important',
            fontSize: getAdaptiveFontSize(formik.values.purchaseBills[index].salBal),
            paddingRight: '10px !important', // 패딩을 명시적으로 강제
            whiteSpace: 'nowrap', // 숫자가 한 줄에 나오도록 강제
            overflow: 'hidden'
          }}
        >
          {getNumberComma(localBal)}
        </TableCell>
        <TableCell align="right" sx={{ width: 130 }}>
          <TextField
            variant="standard"
            required
            size="small"
            fullWidth
            disabled={isLocked}
            id="salAmt"
            // [핵심 1] defaultValue를 사용하여 Formik의 실시간 리렌더링(렉) 차단
            value={localAmt}
            onChange={(e) => {
              setIsApplied(false);
              const val = e.target.value;
              const numAmt = Number(val.replace(/[^0-9.-]+/g, "")) || 0;
              const numVat = Math.floor(numAmt / 10);
              const numTotal = numAmt + numVat;

              // [핵심 수정] 0번 행은 expSales 기준, 1번 행부터는 이전 행의 salBal 기준
              const baseAmount = (index === 0) 
                ? (formik.values.purchaseBills[index]?.expSales || 0) 
                : (formik.values.purchaseBills[index - 1]?.salBal || 0);

              const newBal = baseAmount - numAmt;

              // 로컬 UI 상태 즉시 업데이트 (입력 렉 없음)
              setLocalAmt(val);
              if (isManualVat === true) { 
                setLocalVat(numVat);
              } else {
                const currentVat = Number(String(localVat).replace(/[^0-9.-]+/g, "")) || 0;
                setLocalVat(currentVat);
              }
              setLocalTotalAmt(numTotal);
              setLocalBal(newBal); 
            }}
            onFocus={() => {
              if (index > 0) {
                const prevBal = formik.values.purchaseBills[index - 1].salBal || 0;
                const currentAmt = Number(localAmt.toString().replace(/[^0-9.-]+/g, "")) || 0;
                const newBal = prevBal - currentAmt;
                setLocalBal(newBal);
                formik.setFieldValue(`purchaseBills[${index}].salBal`, newBal);
              } else {
                const expSales = formik.values.purchaseBills[index].expSales || 0;
                const currentAmt = Number(localAmt.toString().replace(/[^0-9.-]+/g, "")) || 0;
                setLocalBal(expSales - currentAmt);
              }
            }}
            onBlur={syncToFormik}
            
            helperText={touchedSalAmt && errorSalAmt ? errorSalAmt : ''}
            error={Boolean(touchedSalAmt && errorSalAmt)}
            sx={{
              '& .MuiInputBase-input': {
                textAlign: 'right',
                fontSize: getAdaptiveFontSize(formik.values.purchaseBills[index].salAmt),
              }
            }}
            InputProps={{ inputComponent: NumberFormatText }}
          />
        </TableCell>
        <TableCell sx={{ width: 130 }}>
          {isManualVat === false ? ( // 직접 입력 모드 (N)
            <TextField
              size="small"
              required
              variant="standard"
              fullWidth
              disabled={isLocked}
              // [수정] defaultValue 대신 localVat 상태와 연결 (실시간 반영)
              value={localVat} 
              onChange={(e) => {
                setIsApplied(false);
                setLocalVat(e.target.value);
              }} // 입력 시 로컬 상태 변경
              onBlur={(e) => {
                const nextVal = e.target.value;
                const numVat = Number(nextVal.replace(/[^0-9.-]+/g, "")) || 0;
                
                // [수정] 정확한 Formik 경로 지정
                const path = `purchaseBills[${index}].salVat`;
                formik.setFieldValue(path, numVat);
                
                if (changeVal) changeVal(nextVal);
                formik.handleBlur(e);
                
                // 합계(totalSalAmt)도 다시 계산해서 Formik에 넣어야 하므로 호출
                syncToFormik(); 
              }}
              InputProps={{ inputComponent: NumberFormatText }}
              sx={{
                '& .MuiInputBase-input': {
                  textAlign: 'right',
                  fontSize: getAdaptiveFontSize(localVat),
                }
              }}
            />
          ) : ( // 자동 계산 모드 (Y)
            <Box sx={{ 
              textAlign: 'right', 
              fontSize: getAdaptiveFontSize(localVat), 
              padding: '4px 0',
              pr: 1 // 우측 정렬 시 약간의 여백
            }}>
              {/* 콤마 포맷팅 처리 */}
              {Number(String(localVat).replace(/[^0-9.-]+/g, "") || 0).toLocaleString()}
            </Box>
          )}
          
          {message !== '' && (
            <FormHelperText sx={{ color: 'error.main' }}>{message}</FormHelperText>
          )}
        </TableCell>
        <TableCell 
          sx={{ 
            width: 130, 
            // 오타 수정: !important 스펠링 확인 및 textAlign 설정
            textAlign: 'right !important', 
            paddingRight: '10px !important', // 숫자 우측 여백을 위해 패딩 추가 추천
          }}
        >
          {/* 숫자가 없을 경우를 대비해 기본값 0 처리 */}
          {getNumberComma(localTotalAmt || 0)}
        </TableCell>
        <TableCell sx={{ width: 120}}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="colDt"
              name="colDt"
              disabled={isLocked}
              value={formik.values.purchaseBills[index].colDt}
              onChange={(newValue) => {
                setIsApplied(false);
                formik.setFieldValue(colDt, newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  fullWidth
                  error={Boolean(touchedColDt && errorColDt)}
                  helperText={
                    touchedColDt && errorColDt ? errorColDt : ''
                  }
                />
              )}
            />
          </LocalizationProvider>
        </TableCell>
        <TableCell sx={{ width: 85, textAlign: 'center' }}>
          {/* 조건: 금액이 0원이고 + 현재 행이 리스트의 마지막 행인 경우에만 삭제 버튼 노출 */}
          {Number(String(formik.values.purchaseBills[index].salAmt || 0).replace(/,/g, "")) === 0 && 
          index === formik.values.purchaseBills.length - 1 ? (
            <IconButton 
              size="small" 
              color="error"
              onClick={() => {
                // 부모의 삭제 함수가 있다면 먼저 실행 (필요 시)
                if (planRowDelete) {
                  planRowDelete(index);
                }
                // Formik 배열에서 해당 행 제거
                const updated = [...formik.values.purchaseBills];
                updated.splice(index, 1);
                formik.setFieldValue('purchaseBills', updated);
              }}
              sx={{ p: 0 }} 
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          ) : (
            <>
              {formik.values.purchaseBills[index].invYn === 'Y' 
                ? '완료' 
                : formik.values.purchaseBills[index].invYn === 'S' 
                  ? '확인 중' 
                  : '예정'}
            </>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};

export default SalesPlanForm;
